import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ChevronRightIcon, MapPinIcon, ShieldAlertIcon, SparklesIcon } from 'lucide-react';
import { alertPlaces, avisQuestions, channelPrefs, topicPrefs } from '../data/avis';
function Toggle({
  label,
  defaultOn
}: {
  label: string;
  defaultOn: boolean;
}) {
  const [on, setOn] = useState(defaultOn);
  return <button type="button" role="switch" aria-checked={on} aria-label={label} onClick={() => setOn(v => !v)} className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2 ${on ? 'bg-ville-indigo' : 'bg-slate-300'}`} data-id="element-3312" data-mp="33ijoz2jigspg">
      <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-[left] duration-150 ease-ville ${on ? 'left-[22px]' : 'left-0.5'}`} data-id="element-3313" data-mp="spp2srsegd34" />
    </button>;
}
export function ParametresAvis() {
  const [question, setQuestion] = useState('');
  return <main className="bg-white" data-id="element-3314" data-mp="3zu5sa5cobpi">
      <div className="mx-auto max-w-[860px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3315" data-mp="3yswaa3zfx9w">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-3316" data-mp="hqz498wzexy9">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-3317" data-mp="csxj8ifzwok5">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3318" data-mp="3l9ijnauka9bn" />
          <Link to="/notifications" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-3319" data-mp="3h75r5o4ts7wt">
            Notifications
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3320" data-mp="3v397qems0hqt" />
          <span aria-current="page" data-id="element-3321" data-mp="3q4xxw3whe78l">Paramètres</span>
        </nav>

        <header className="mt-4" data-id="element-3322" data-mp="1aeleh00pt0u3">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3323" data-mp="1adjrpyac6pwj">
            Préférences de notifications
          </h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-3324" data-mp="1dhiu9g37ce4w">
            Choisissez les informations que vous souhaitez recevoir et la façon dont la Ville peut vous joindre.
          </p>
        </header>

        <section aria-labelledby="canaux-titre" className="mt-10" data-id="element-3325" data-mp="1mhecu5z37bey">
          <h2 id="canaux-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-3326" data-mp="1rgqvsfmu7yc9">
            Comment souhaitez-vous être informé ?
          </h2>
          <ul className="mt-4 space-y-2" data-id="element-3327" data-mp="tul4p2jdb9ux">
            {channelPrefs.map(channel => <li key={channel.id} className="flex items-center gap-4 rounded-2xl border border-slate-200 px-5 py-4" data-id="element-3328" data-mp="ysmppt0ctj91">
                <span className="min-w-0 flex-1" data-id="element-3329" data-mp="13p3d2kzqbtl2">
                  <span className="block font-bold text-ville-navy" data-id="element-3330" data-mp="18i68kyo2hd3w">{channel.label}</span>
                  <span className="block text-sm text-slate-500" data-id="element-3331" data-mp="b30rb7rt3823">{channel.destination}</span>
                </span>
                <Toggle label={channel.label} defaultOn={channel.enabled} data-id="element-3332" data-mp="g0tzu7gl0e5j" />
              </li>)}
          </ul>
          <Link to="/mon-profil" className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-indigo hover:underline" data-id="element-3333" data-mp="8hknc5cs3zc9">
            Modifier mes coordonnées
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3334" data-mp="3ung6cwmkb4fa" />
          </Link>
        </section>

        <section aria-labelledby="essentielles-titre" className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-3335" data-mp="3ppy8q2dzwbml">
          <h2 id="essentielles-titre" className="flex items-center gap-2 text-[15px] font-extrabold text-ville-navy" data-id="element-3336" data-mp="3gxmgcazbme3z">
            <ShieldAlertIcon className="h-5 w-5 text-red-600" aria-hidden="true" data-id="element-3337" data-mp="3bzky1s9pyitk" />
            Alertes de sécurité et d’urgence
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-3338" data-mp="36xvmmbil434y">
            Ces communications peuvent être envoyées lorsqu’elles sont nécessaires à votre sécurité ou à celle de la
            communauté. Elles ne peuvent donc pas être désactivées complètement.
          </p>
          <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-slate-600" data-id="element-3339" data-mp="3mqg2hhj4mvc5">
            <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-3340" data-mp="3dxcn33ox88ev" />
            Toujours actives
          </p>
        </section>

        <section aria-labelledby="interets-titre" className="mt-10" data-id="element-3341" data-mp="3hxn030b4rz38">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-3342" data-mp="33ynddy76hu9p">Mes préférences</p>
          <h2 id="interets-titre" className="mt-1 text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-3343" data-mp="38ysyeviy0iit">
            Ce qui vous intéresse
          </h2>
          <ul className="mt-4 space-y-2" data-id="element-3344" data-mp="2v0l4yxl47zce">
            {topicPrefs.map(topic => <li key={topic.id} className="flex items-center gap-4 rounded-2xl border border-slate-200 px-5 py-4" data-id="element-3345" data-mp="2z0lqf26mtasy">
                <span className="min-w-0 flex-1" data-id="element-3346" data-mp="t50x6h24boz7">
                  <span className="block font-bold text-ville-navy" data-id="element-3347" data-mp="x90a6po6w5nt">{topic.label}</span>
                  <span className="block text-sm text-slate-500" data-id="element-3348" data-mp="2hq9gc893yz55">{topic.description}</span>
                </span>
                <Toggle label={topic.label} defaultOn={topic.enabled} data-id="element-3349" data-mp="2dq7gm4mxofsi" />
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="lieux-titre" className="mt-10" data-id="element-3350" data-mp="2rhvuacctzcbl">
          <h2 id="lieux-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-3351" data-mp="2mot50gf36p17">
            Mes lieux
          </h2>
          <p className="mt-1 text-[15px] text-slate-600" data-id="element-3352" data-mp="31gv2jttop5y2">
            Vos lieux permettent à la Ville de vous transmettre les avis qui vous concernent.
          </p>
          <ul className="mt-4 space-y-2" data-id="element-3353" data-mp="3ae5dfe2lat2g">
            {alertPlaces.map(place => <li key={place.id} className="flex items-center gap-4 rounded-2xl border border-slate-200 px-5 py-4" data-id="element-3354" data-mp="35g3s0mhoyhnt">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-3355" data-mp="1g2747c4a5x6k">
                  <MapPinIcon className="h-5 w-5" data-id="element-3356" data-mp="3b4kc5622wicl" />
                </span>
                <span className="min-w-0 flex-1" data-id="element-3357" data-mp="3b6oo8ba4snny">
                  <span className="block font-bold text-ville-navy" data-id="element-3358" data-mp="3g2vktdgn0mt8">{place.address}</span>
                  <span className="block text-sm text-slate-500" data-id="element-3359" data-mp="3l28g8mlkr27f">{place.label}</span>
                </span>
                <Toggle label={`Alertes pour ${place.address}`} defaultOn data-id="element-3360" data-mp="3p4llzb0bn047" />
              </li>)}
          </ul>
          <Link to="/mon-profil" className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-indigo hover:underline" data-id="element-3361" data-mp="3u2n5fx1nt1g7">
            Gérer mes adresses
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3362" data-mp="7odi7r9gtzh0" />
          </Link>
        </section>

        <section aria-labelledby="atna-parametres-titre" className="mt-10 rounded-3xl border border-slate-200 p-5" data-id="element-3363" data-mp="cmf22eepu2tj">
          <h2 id="atna-parametres-titre" className="flex items-center gap-2 text-[15px] font-extrabold text-ville-navy" data-id="element-3364" data-mp="gmgsfrf039ti">
            <SparklesIcon className="h-5 w-5 text-ville-indigo" aria-hidden="true" data-id="element-3365" data-mp="265nqesmdy6fe" />
            Une question sur vos avis ?
          </h2>
          <p className="mt-1.5 text-sm leading-relaxed text-slate-600" data-id="element-3366" data-mp="215j5mqeg2pjd">
            ATNA peut vous expliquer pourquoi vous recevez une communication ou comment modifier vos préférences.
          </p>

          <form onSubmit={event => event.preventDefault()} className="mt-4 flex items-center gap-2 rounded-full border border-slate-200 py-1.5 pl-4 pr-1.5 focus-within:border-ville-indigo" data-id="element-3367" data-mp="1s6xrr8jx3yox">
            <label htmlFor="atna-parametres" className="sr-only" data-id="element-3368" data-mp="2kvd2vjzxhwuz">
              Posez votre question
            </label>
            <input id="atna-parametres" type="text" value={question} onChange={event => setQuestion(event.target.value)} placeholder="Demander à ATNA…" className="min-w-0 flex-1 border-0 bg-transparent py-2 text-sm text-ville-navy placeholder:text-slate-400 focus:outline-none" data-id="element-3369" data-mp="2g1ifa5h7cxqm" />
            <button type="submit" className="rounded-full bg-ville-indigo px-4 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-3370" data-mp="2c4joqf4c7b6c">
              Demander
            </button>
          </form>

          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-3371" data-mp="2uwvpixfce4ed">
            {avisQuestions.map(item => <li key={item} data-id="element-3372" data-mp="2zux71dx4dvnq">
                <button type="button" onClick={() => setQuestion(item)} className="rounded-full bg-slate-50 px-3.5 py-1.5 text-sm text-slate-600 transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-3373" data-mp="2zt2vgq7qnfwb">
                  {item}
                </button>
              </li>)}
          </ul>
        </section>
      </div>
    </main>;
}